<template>
    <div>
        <el-form ref="insertForm" :model="$parentInfo.dialog_DeleteTeacher.insertForm" label-position="top">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="学科">
                        <el-select v-model="$parentInfo.dialog_DeleteTeacher.insertForm.subject_id"
                                   filterable
                                   @change="handleChooseTeacher($parentInfo.dialog_DeleteTeacher.insertForm.subject_id)"
                                   placeholder="请选择"
                                    :loading="search_loading">
                            <el-option
                                    v-for="item in $parentInfo.subjects"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="老师">
                        <el-select v-model="$parentInfo.dialog_DeleteTeacher.insertForm.teacher_subject_id" filterable
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in teachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col align="right" :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="handleDeleteTeacher()"
                                   :loading="$parentInfo.dialog_DeleteTeacher.button_loading">删除
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>

</template>

<script>
    export default {
        name: "Dialog_DeleteTeacher",
        data() {
            return {
                teachers: [],
                search_loading: true,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.dialog_DeleteTeacher.insertForm = {
                teacher_subject_id: '',
                subject_id: '',
            };
            this.handleChooseTeacher();
        },
        methods: {
            handleDeleteTeacher() {
                this.$parentInfo.dialog_DeleteTeacher.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'remove_teacher_form_subject', {
                    'teacher_subject_id': this.$parentInfo.dialog_DeleteTeacher.insertForm.teacher_subject_id,
                    'semester_id': this.$parentInfo.filter.semester_id,
                });
            },
            handleChooseTeacher(subject_id = 0) {
                this.search_loading= true;
                this.teachers = [];
                if (subject_id === 0) {
                    for (let i in this.$parentInfo.teachers) {
                        for (let j in this.$parentInfo.teachers[i]) {
                            this.teachers.push(this.$parentInfo.teachers[i][j]);
                        }
                    }
                } else {
                    for (let i in this.$parentInfo.teachers) {
                        for (let j in this.$parentInfo.teachers[i]) {
                            if (this.$parentInfo.teachers[i][j].subject_id === subject_id) {
                                this.teachers.push(this.$parentInfo.teachers[i][j]);
                            }
                        }
                    }
                }
                this.search_loading = false;
            },
        }
    }
</script>

<style>
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3000;
    }

    .modal-dialog {
        max-width: 500px;
        margin: 30px auto;
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        border-bottom: 1px solid #e9ecef;
    }

    .modal-header {
        font-size: 12px;
    }

    .modal-title {
        margin: 0;
        line-height: 1.5;
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 15px;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, .18);
        border-radius: .3rem;
        outline: 0;
        min-height: 300px;
        box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.12);
    }

    .modal .close {
        font-size: 20px;
        text-shadow: 0 1px 0 #fff;
    }

    .modal .close:hover {
        opacity: .5;
    }
</style>